/**
 * List Schema of MotoristaCancelamentoCarga
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {MotoristaCancelamentoCarga} from '@/model/resource/MotoristaCancelamentoCarga'

/* TODO: review generated schema */
export class ListMotoristaCancelamentoCargaSchema extends Schema {
  readonly name = 'ListMotoristaCancelamentoCarga'

  readonly fieldSet: FieldSet<MotoristaCancelamentoCarga> = {
    idCancelamentoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    motorista: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.motorista?.$id,
      },
    }),
    data: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.data),
      },
    }),
  }
}
